module.exports = __webpack_public_path__ + "static/Green shape-ef4c1c556095ceae425a4b0ff8d2e757.png";